<template>
  <headboard></headboard>
  <div class="" style="padding-left: 5%; padding-right: 5%">
    <div class="row mt-5">
      <div class="col-sm-12">
        <div class="instant">
          <h2 class="modspec_title">Instant Pricing [beta]</h2>
          <p>
            Seamlessly coordinate energy compliance for your residential or commercial construction project.
          </p>
          <p style="font-size: smaller">
            Please Note: Our scoping tool is in early stage development and as
            such, we welcome any feedback or suggestions to improve its
            functionality.
          </p>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-2">
                Project Reference
                <span id="spnProjectReference" style="cursor: pointer" class="text-danger" @click="
                  showInformation({
                    title: 'Reference',
                    body: 'Please provide a project reference',
                  })
                  ">*</span>
              </div>
              <div class="col-sm-4">
                <input type="text" class="form-control" placeholder="" v-model="refName" id="txtReference" />
              </div>
            </div>
            <div class="row mt-2" v-if="idProject">
              <div class="col-sm-2"></div>
              <div class="col-sm-4">
                <input class="form-check-input" type="checkbox" name="chkVariation" id="chkVariation" value="0"
                  v-model="variation" />
                <label class="form-check-label modspec_font12" for="chkVariation">&nbsp;
                  Variation </label>
              </div>

            </div>
            <div class="row mt-2" v-if="currentQuoteId">
              <div class="col-sm-2"></div>
              <div class="col-sm-6 modspec_font12 text-muted">
                Editing from quote #{{ currentQuoteId }}. Saving will deactivate the original quote.
              </div>
            </div>
            <div class="row mt-4" v-if="existenItems">
              <div class="col-sm-2"><b>Total:</b></div>
              <div class="col-sm-4 text-star">
                <b>${{ totalItems }}</b>
              </div>
            </div>

            <div v-if="existenItems" class="row mt-5">
              <div class="col-sm-12">Items</div>
            </div>
            <div v-if="existenItems" class="row mt-2">
              <div class="col-sm-12">
                <div class="accordion accordion-flush" id="accordionFlushExample">
                  <div class="accordion-item" v-for="item in items" :key="item.IdSource || item.Name">
                    <div class="accordion-header" id="flush-headingOne">
                      <button class="accordion-button collapsed d-flex justify-content-between align-items-center" type="button" data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                        <span>{{ item.Name }}&nbsp;&nbsp;&nbsp;<b>${{ item.Price }}</b></span>
                        &nbsp;&nbsp;&nbsp;
                        <button class="btn btn-sm btn-danger" @click.stop="deleteItem(item)">
                          <i class="bi bi-trash"></i>
                        </button>
                      </button>
                    </div>
                    <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne"
                      data-bs-parent="#accordionFlushExample">
                      <div class="accordion-body">
                        <p>{{ item.Description }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div v-if="isAdmin" class="col-sm-2">                
                <button v-if="isAdmin" type="button" class="btn btn-primary" @click="addItem">
                  Add Generic Item
                </button>
              </div>
              <div class="col-sm-2">
                <button type="button" class="btn btn-primary" @click="addService">
                  Add Service
                </button>
              </div>
              <div class="col-sm-4"></div>
              <div class="col-sm-2">
                <div v-if="isAdmin && existenItems" class="d-inline-block">
                  <input class="form-check-input" type="checkbox" name="chkQuoteSendMail" id="chkQuoteSendMail"
                    value="1" v-model="sendQuoteMail" />
                  <label class="form-check-label modspec_font12" for="chkQuoteSendMail">Send email to client
                  </label>
                </div>
              </div>
              <div class="col-sm-2">
                <loadingbutton v-if="existenItems" :loading="isLoadingSave" @pressed="saveAllQuote"
                  :classButton="'btn btn-primary'" :icon="'bi bi-save'" buttonText="Finish Quote" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!------------------------------------------------------------->
    <div v-if="newService" class="row mt-3">
      <div class="col-sm-12 mb-5">
        <assessment @savedAssessment="savedAssessment($event)" :idCliente="idClient" :idUsuario="idUser"
          :initialQuote="currentServiceQuote" />
      </div>
    </div>
    <!------------------------------------------------------------->
  </div>

  <NewQuoteModal ref="modalRef" @add-item="addGenericItem" />

  <!-----PERTENECE A SUMMARY, da problemas si se coloca adentro-------------------------------------->
  <button style="display: none" type="button" class="btn btn-primary" data-bs-toggle="modal"
    data-bs-target="#mdlInfoUrgentLead" id="btnOpenInfoUrgentLead">
    Open
  </button>
  <div class="modal fade" id="mdlInfoUrgentLead" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Urgent Lead Time</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <p>
                If our standard lead time does not fit the project timeline, and
                the assessment is needed to be completed as a matter of urgency,
                you can opt to pay a premium and we will start the assessment
                immediately, ensuring it is completed as soon as is possible.
                Depending on the project size, it may be possible for us to have
                results to you same day. This requires us to push back other
                assessments.
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div>
    <selectUser @saved="clientSaved($event)"></selectUser>
  </div>

  <infomodal ref="modalInformationRef" />
</template>

<script setup>
import { onMounted, ref, computed, toRaw, provide } from "vue";
import headboard from "../components/header.vue";
import assessment from "@/components/assessment/new-assessment.vue";
import vtc from "@/helpers/vtc.js";
import { useRoute } from "vue-router";
import infomodal from "@/components/global/info-modal.vue";
import selectUser from "@/components/global/select-user.vue";
import NewQuoteModal from "../components/item-modal.vue";
import loadingbutton from "@/components/global/loading-button.vue";

//--------------------------------------------
const route = useRoute();
const load = ref(false);
const items = ref([]);
const refName = ref("");
const variation = ref(false)
const newService = ref(false);
const modalInformationRef = ref(null);
const idUser = ref("");
const idClient = ref(0);
const files = [];
const sendQuoteMail = ref(true);
const isLoadingSave = ref(false);
const thereAreItems = ref(false);
const idProject = ref(null);
const currentQuoteId = ref(null);
const currentServiceQuote = ref(null);

//------------
provide("hayItem", thereAreItems);

onMounted(async () => {
  if (route.params.id) {
    let s = route.params.id;
    //recibe dos parámetro idUsuario e idCliente
    let r = s.split("|");
    if (r[0] != "null") {
      idUser.value = r[0];
    }
    if (r[1] != "null") idClient.value = parseInt(r[1]);
    if (r.length >= 3 && r[2] != "null") idProject.value = parseInt(r[2]);
    if (r.length >= 4 && r[3] != "null") currentQuoteId.value = parseInt(r[3]);

    console.log("longitud----=>", r.length);
  }

  let usr = vtc.getUsuarioLogueado();

  if (idClient.value == 0 && usr != null) {
    idClient.value = parseInt(usr.idClient);
    idUser.value = usr.id;
  }

  await init();
  if (currentQuoteId.value) await loadCurrentQuote();
});

const init = async () => {
  let c = vtc.getConfig();
  console.log("configuration", c);
  load.value = true;
};

const isAdmin = computed(() => {  
  let usrr = vtc.getUsuarioLogueado();  
  if (usrr) {
    return usrr.isAdmin
  }
  return false;
});

const existenItems = computed(() => {
  return items.value.length > 0;
});

const totalItems = computed(() => {
  if (!existenItems.value) return 0;
  let total = 0;
  for (const qi of items.value) {
    total += qi.Price;
  }
  return total
})
const modalRef = ref(null);

const addItem = () => {
  modalRef.value.open(); // calls defineExpose({ open })
};

const addService = () => {
  thereAreItems.value = items.value.length > 0;
  let f = items.value.filter((x) => x.TieneBloqueo == true);

  if (f.length > 0) {
    alert("A HandBook quote must be created separately");
    return false;
  }
  newService.value = true;
};

const addGenericItem = (item) => {
  items.value.push(item);
};

const loadCurrentQuote = async () => {
  try {
    const quote = await vtc.vtcFetch("/Quote/GetQuote/?id=" + currentQuoteId.value, null, "API2");
    refName.value = quote.name || quote.Name || "";
    if ((!idClient.value || idClient.value == 0) && quote.idClient) idClient.value = parseInt(quote.idClient);
    if (!idProject.value && quote.idProject) idProject.value = parseInt(quote.idProject);

    const quoteItems = quote.items || [];
    const serviceItems = quoteItems.filter((item) => (item.idType || item.IdType) == 100);
    //const genericItems = quoteItems.filter((item) => (item.idType || item.IdType) != 100);

    /*items.value = genericItems.map((item) => ({
      IdQuote: 0,
      IdType: item.idType || item.IdType,
      IdSource: item.idSource || item.IdSource || 0,
      Name: item.name || item.Name,
      Description: item.description || item.Description,
      Price: item.price || item.Price || 0,
      Quantity: item.quantity || item.Quantity || 0,
      Discount: item.discount || item.Discount || 0,
      TieneBloqueo: item.tieneBloqueo || item.TieneBloqueo || false,
    }));
*/

    if (serviceItems.length > 0) {
      currentServiceQuote.value = serviceItems[0].assessment;
      newService.value = true;
    }

  } catch (err) {
    console.log("Error loading current quote", err);
    alert("The current quote could not be loaded. You can still create a new quote.");
  }
};

const deleteItem = (itemToDelete) => {
  if(!confirm("Are you sure to delete?")) return false
  items.value = items.value.filter(item => item !== itemToDelete);
};

const saveAllQuote = async () => {
  if (idClient.value == 0) {
    document.getElementById("btnOpenMdlSelectUser").click();
    return false;
  }

  isLoadingSave.value = true;
  let q = getDto();

  let formData = new FormData();

  if (files.length > 0) {
    let fills = toRaw(files);
    let fl = toRaw(fills[0]);
    fl.forEach(function (f) {
      formData.append("file[]", f);
    });
  }

  formData.append("quote", JSON.stringify(q));

  try {
    const res = await vtc.vtcFetch(`/Quote/SaveQuote`, formData, "API2")
    console.log(res);

    alert("The quote has been saved");

    isLoadingSave.value = false;
    let rui = vtc.getUsuarioLogueado();

    if (rui.isAdmin) {
      let url = vtc.getConfig().getHomeUrl();
      if (idProject.value) {
        url = url + "/administration/project/" + idProject.value;
      } else {
        url = url + "/administration/client/" + idClient.value;
      }
      window.location.href = url;
      return true;
    }
    window.location.href = vtc.getConfig().getHomeUrl() + "/user";
  } catch (err) {
    console.log("Error saving quote", err);
    alert('An error has ocurred, try again')
    isLoadingSave.value = false;
  }

};

const savedAssessment = (assmnt) => {
  let q = JSON.parse(assmnt.Resume);

  let bloquear = assmnt.IdServiceType == 5 || assmnt.IdServiceType == 6; //si es un nuevo HB

  //necesitamos guardar todo osea assmnt.Resume
  let assmt = {
    IdClient: assmnt.IdClient,
    IdServiceType: assmnt.IdServiceType,
    Name: q.name,
    NumOrientations: assmnt.NumOrientations,
    Address: assmnt.Address,
    NumClimateZones: assmnt.NumClimateZones,
    ClimateZones: assmnt.ClimateZones,
    NumWeatherFiles: assmnt.NumWeatherFiles,
    WeatherFiles: assmnt.WeatherFiles,
    ConstructionDetails: assmnt.ConstructionDetails,
    Notes: assmnt.Notes,
    IsLeadTime: assmnt.IsLeadTime,
    Total: assmnt.Price,
    Summary: q.text,
    IncludeAssessments: assmnt.IncludeAssessments,
    Resume: assmnt.Resume,
    Buildings: assmnt.Buildings,
    TotalCrude: assmnt.TotalCrude,
    TotalDiscount: assmnt.TotalDiscount,
    TotalIncludeAssisment: assmnt.TotalIncludeAssisment,
    TotalUrgentIncrementTime: assmnt.TotalUrgentIncrementTime,
    PercentUrgentIncrementTime: assmnt.PercentUrgentIncrementTime,
  };

  ///////////////
  let item = {
    IdQuote: 0,
    IdType: "100",
    Assessment: assmt, //aca van los files
    Name: assmt.Name,
    Description: assmt.Summary,
    Price: assmnt.Price,
    Quantity: 0,
    Discount: assmnt.TotalDiscount,
    TieneBloqueo: bloquear, //Si es HB no se puede agregar o nuevos
  };

  ///////////////
  if (items.value.length > 0 && bloquear) {
    alert("The HB assessment must be unique");
  } else {
    files.push(assmnt.Files);
    items.value.push(item);
  }
  newService.value = false;
};

const showInformation = (info) => {
  modalInformationRef.value.showInformation(info);
};

const getDto = () => {
  let dto = { name: "", Items: [] };
  dto.IdClient = idClient.value;
  dto.Name = refName.value;
  dto.Variation = variation.value;
  dto.Items = items.value;
  dto.IdUser = idUser.value;
  dto.SendMail = sendQuoteMail.value;
  dto.IdProject = idProject.value;
  dto.OriginalQuoteId = currentQuoteId.value;

//forzar variation, que al final es lo que hace que se edite el proyecto, si fue una edicion
  if(currentQuoteId.value > 0) dto.Variation = true;


  dto.Total = 0;
  for (const imt of items.value) {
    if (imt.Price) {
      dto.Total += imt.Price;
    }
  }

  return dto;
};

const clientSaved = (id) => {
  idClient.value = id;
  document.getElementById("btnCloseMdlSelectUser").click();
  saveAllQuote();
};
</script>
<style></style>
